export const SKELETON_VARIANTS = {
  BLOCK: "block",
  TEXT: "text",
  CIRCLE: "circle",
} as const;
